import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikurbaniabushire() {



    const cardData =
    {
        keyword: 'Pune to Nashik Urbania Bus Hire',
        heading: 'Urbania on rent in pune: Pune to Nashik Urbania Bus Hire',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Pune to Nashik Urbania Bus Hire services for families, corporate groups, tourists, and event travelers commuting between the two cities. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for one-way and round-trip travel, airport transfers, corporate tours, and group journeys from Pune to Nashik. With professional chauffeurs, flexible rental options, and convenient doorstep pickup from all major areas of Pune including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free intercity travel experience. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Nashik.',

        top: 'Top Places to Visit in Nashik with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and one of the most sacred pilgrimage sites in India. Located near the Brahmagiri hills, it is also the origin point of the Godavari River. The temple features unique architecture with a black stone structure and a sacred lingam representing Brahma, Vishnu, and Shiva. Devotees visit throughout the year, especially during religious occasions like Kumbh Mela."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous winery and a major attraction in Nashik, often referred to as the Wine Capital of India. Visitors can enjoy wine tasting tours, vineyard walks, and scenic views of lush green landscapes. The annual SulaFest music festival adds to its popularity, making it a perfect destination for wine lovers and tourists."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a sacred area in Nashik closely associated with the Ramayana. It is believed that Lord Rama, Sita, and Lakshmana stayed here during their exile. The area includes important sites like Sita Gufa, Kalaram Temple, and Ram Kund, making it a significant spiritual destination attracting pilgrims from across India."
  },
  {
    "title": "Ram Kund",
    "description": "Ram Kund is a holy bathing ghat on the banks of the Godavari River where devotees perform rituals and immerse ashes of loved ones. It holds immense religious significance and is one of the key locations during the Kumbh Mela. The surroundings are always vibrant with spiritual activities and temple bells."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is an ancient and revered temple dedicated to Lord Rama, known for its black stone idol. Built in the 18th century, the temple showcases beautiful architecture with tall spires and intricate carvings. It is one of the most important religious landmarks in Nashik and attracts thousands of devotees."
  },
  {
    "title": "Pandavleni Caves",
    "description": "The Pandavleni Caves are a group of ancient rock-cut caves dating back to the 1st century BCE. Located on a hill, these caves feature Buddhist carvings, inscriptions, and prayer halls. Visitors can enjoy panoramic views of Nashik city after a short trek, making it a blend of history and nature."
  },
  {
    "title": "Anjneri Hills",
    "description": "Anjneri Hills are believed to be the birthplace of Lord Hanuman and are a popular trekking destination near Nashik. The scenic trail, lush greenery, and peaceful surroundings attract nature lovers and adventure seekers. The hill also has a small temple dedicated to Hanuman."
  },
  {
    "title": "Dudhsagar Falls (Someshwar)",
    "description": "Dudhsagar Falls near Someshwar Temple is a beautiful seasonal waterfall known for its milky white cascading water. It is a popular picnic spot during the monsoon season, offering a refreshing natural escape with scenic surroundings and calm vibes."
  },
  {
    "title": "Muktidham Temple",
    "description": "Muktidham Temple is a unique marble temple complex that features replicas of all the 12 Jyotirlingas in India. Built with pure white marble, the temple is known for its cleanliness, spiritual atmosphere, and inscriptions of verses from the Bhagavad Gita on its walls."
  },
  {
    "title": "Gangapur Dam",
    "description": "Gangapur Dam is a popular spot for picnics and sunset views in Nashik. Surrounded by natural beauty and calm waters, it is a great place for relaxation, photography, and enjoying peaceful moments away from the city’s hustle."
  }
],



 "services": [
    {
      "name": "Pune to Nashik Urbania Bus Hire",
      "description": "Pune to Nashik Urbania Bus Hire offers a comfortable and reliable travel solution for groups traveling between Pune and Nashik. With spacious seating, modern interiors, and professional chauffeurs, it ensures a smooth highway journey. Ideal for family trips, corporate travel, and group tours, this service guarantees safety, comfort, and punctual travel."
    },
    {
      "name": "Pune to Nashik Urbania Bus Booking",
      "description": "Pune to Nashik Urbania Bus Booking provides quick and hassle-free booking options for your travel needs. With transparent pricing, easy availability, and well-maintained vehicles, customers can plan their trip efficiently. Suitable for both advance and last-minute bookings, this service ensures a seamless travel experience."
    },
    {
      "name": "Pune to Nashik Urbania Bus Rental",
      "description": "Pune to Nashik Urbania Bus Rental offers flexible rental plans for one-way and round trips. Perfect for family vacations, corporate journeys, and group travel, it ensures comfortable seating, AC travel, and experienced drivers for a stress-free journey on the Pune to Nashik route."
    },
    {
      "name": "Pune to Nashik Urbania Van Hire",
      "description": "Pune to Nashik Urbania Van Hire provides premium van services for small to medium-sized groups. With comfortable seating, ample luggage space, and smooth ride quality, it is ideal for leisure trips, religious tours, and business travel between Pune and Nashik."
    },
    {
      "name": "Urbania Bus Hire Pune to Nashik",
      "description": "Urbania Bus Hire Pune to Nashik ensures safe and convenient travel with well-maintained vehicles and professional drivers. Designed for group travel, it offers spacious interiors, reliable service, and smooth highway driving for a comfortable journey."
    },
    {
      "name": "Urbania Bus Booking Pune to Nashik",
      "description": "Urbania Bus Booking Pune to Nashik makes it easy to reserve your vehicle with flexible options and transparent pricing. Whether for family trips or corporate travel, customers can rely on timely service and comfortable travel arrangements."
    },
    {
      "name": "Pune to Nashik Urbania Bus Fare",
      "description": "Pune to Nashik Urbania Bus Fare offers competitive and transparent pricing based on distance, duration, and travel requirements. Customers receive clear fare details with no hidden charges, making it a cost-effective and reliable option for group travel."
    },
    {
      "name": "Urbania Bus Rental Pune to Nashik",
      "description": "Urbania Bus Rental Pune to Nashik provides customized travel packages for different group sizes and trip durations. With comfortable seating, AC facilities, and experienced chauffeurs, it ensures a smooth and enjoyable journey."
    },
    {
      "name": "Pune to Nashik Urbania 9/10/13 Seater Hire",
      "description": "Pune to Nashik Urbania 9/10/13 Seater Hire offers multiple seating options to suit different group sizes. Whether for family travel, corporate trips, or small group tours, customers can choose the right vehicle for a comfortable and convenient journey."
    },
    {
      "name": "Pune to Nashik Urbania Bus Service",
      "description": "Pune to Nashik Urbania Bus Service provides dependable transportation with well-maintained vehicles and trained drivers. Known for punctuality and comfort, it is ideal for regular travel, tours, and group bookings."
    },
    {
      "name": "Urbania Bus for Pune to Nashik Trip",
      "description": "Urbania Bus for Pune to Nashik Trip ensures a relaxing and enjoyable journey with spacious seating, AC comfort, and smooth ride quality. Perfect for leisure travel, family outings, and corporate trips, it delivers a premium travel experience."
    },
    {
      "name": "Pune to Nashik Urbania Travel Booking",
      "description": "Pune to Nashik Urbania Travel Booking offers easy planning with flexible travel options and reliable service. Customers can book vehicles for customized itineraries, ensuring convenience and comfort throughout the journey."
    },
    {
      "name": "One Way Pune to Nashik Urbania Bus",
      "description": "One Way Pune to Nashik Urbania Bus provides convenient one-way travel solutions for passengers who do not require return trips. With affordable pricing, punctual pickups, and comfortable seating, it is ideal for business travel and quick transfers."
    },
    {
      "name": "Round Trip Pune to Nashik Urbania Bus",
      "description": "Round Trip Pune to Nashik Urbania Bus offers complete travel solutions for return journeys with flexible scheduling. Perfect for weekend trips, family travel, and corporate tours, it ensures smooth coordination, comfort, and reliable service."
    }
  ],
  "tableData": [
    ["Pune to Nashik Urbania Bus Hire", "Pune to Nashik Urbania Bus Booking"],
    ["Pune to Nashik Urbania Bus Rental", "Pune to Nashik Urbania Van Hire"],
    ["Urbania Bus Hire Pune to Nashik", "Urbania Bus Booking Pune to Nashik"],
    ["Pune to Nashik Urbania Bus Fare", "Urbania Bus Rental Pune to Nashik"],
    ["Pune to Nashik Urbania 9/10/13 Seater Hire", "Pune to Nashik Urbania Bus Service"],
    ["Urbania Bus for Pune to Nashik Trip", "Pune to Nashik Urbania Travel Booking"],
    ["One Way Pune to Nashik Urbania Bus", "Round Trip Pune to Nashik Urbania Bus"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Nashik Urbania Bus Hire",
    "WhyChoosedescription": "Pune to Nashik Urbania Bus Hire is ideal for comfortable and spacious group travel, perfect for family trips, corporate travel, religious visits, and outstation journeys."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
    "WhyChoosedescription": "Pune to Nashik Urbania Bus Hire offers well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and relaxed highway journey."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Pune to Nashik Urbania Bus Hire comes with skilled drivers familiar with the Pune–Nashik highway routes, ensuring safe, timely, and stress-free travel."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Choose Pune to Nashik Urbania Bus Hire for competitive rates with no hidden charges, making intercity group travel reliable and budget-friendly."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Pune to Nashik Urbania Bus Hire provides round-the-clock assistance for bookings, schedule changes, and last-minute travel requirements."
  },
  {
    "WhyChooseheading": "Flexible Intercity Travel Packages",
    "WhyChoosedescription": "Pune to Nashik Urbania Bus Hire is available for one-way trips, round trips, corporate travel, religious tours, and customized intercity packages."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "All Urbania vehicles for Pune to Nashik travel are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Service",
    "WhyChoosedescription": "Pune to Nashik Urbania Bus Hire guarantees on-time pickups and dependable service, ensuring smooth and stress-free intercity travel."
  }
]
}

const faqData = [
    {
        question: 'Is Pune to Nashik Urbania Bus Hire available for one-way and round trips?',
        answer: 'Yes, Pune to Nashik Urbania Bus Hire is available for one-way, round-trip, and customized intercity travel packages.',
    },
    {
        question: 'How can I book Pune to Nashik Urbania Bus Hire?',
        answer: 'You can book Pune to Nashik Urbania Bus Hire via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Pune to Nashik Urbania Bus Hire for group travel?',
        answer: 'Pune to Nashik Urbania Bus Hire offers spacious seating, ample luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Pune to Nashik Urbania Bus Hire suitable for religious trips?',
        answer: 'Yes, Pune to Nashik Urbania Bus Hire is perfect for religious travel, including visits to Trimbakeshwar and other pilgrimage sites.',
    },
    {
        question: 'Are drivers experienced with Pune to Nashik Urbania Bus Hire?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles on the Pune–Nashik route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Pune to Nashik Urbania Bus Hire allows flexible pickup and drop-off locations across Pune and Nashik.',
    },
    {
        question: 'Is Pune to Nashik Urbania Bus Hire available 24x7?',
        answer: 'Yes, Pune to Nashik Urbania Bus Hire operates 24x7 to meet intercity travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Pune to Nashik Urbania Bus Hire accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free travel experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Nilesh Deshpande',
        feedback: 'We booked Pune to Nashik Urbania Bus Hire for a family trip. The vehicle was spacious, clean, and the journey was very comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Aarti Kulkarni',
        feedback: 'Pune to Nashik Urbania Bus Hire provided reliable and punctual service for our group travel. The driver was professional and experienced. Highly recommended!',
        rating: 5,
    },
];




































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Urbania Bus Hire",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-to-nashik-urbania-bus-hire.jpg",
  "description": "Pune to Nashik Urbania Bus Hire offers premium Force Urbania rental services for one-way and round trips. Ideal for corporate travel, family trips, group tours, and outstation journeys. Choose from 9, 10, and 13 seater AC luxury Urbania buses with professional chauffeur-driven service at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "980",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-nashik-urbania-bus-hire"
  }
};










    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Nashik Urbania Bus Hire | Luxury AC Urbania Rental 
  </title>

  <meta
    name="description"
    content="Book Pune to Nashik Urbania bus hire for one-way and round trips. Luxury AC Urbania rental with 9, 10, and 13 seater options for corporate travel, family trips, and group tours at affordable rates."
  />

  <meta
    name="keywords"
    content="pune to nashik urbania bus hire, pune to nashik urbania bus booking, pune to nashik urbania bus rental, pune to nashik urbania van hire, urbania bus hire pune to nashik, urbania bus booking pune to nashik, pune to nashik urbania bus fare, urbania bus rental pune to nashik, pune to nashik urbania 9 seater 10 seater 13 seater hire, pune to nashik urbania bus service, urbania bus for pune to nashik trip, pune to nashik urbania travel booking, one way pune to nashik urbania bus, round trip pune to nashik urbania bus"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/119.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikurbaniabushire;